import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ClickLayer } from '../../../ga4';

const FormattedMessageWithClass = (props) => (
  <FormattedMessage {...props}>
    {(txt) =>( 
        <span
          className={props.className || ''}
          dangerouslySetInnerHTML={{ __html: txt }}
        />
    )}
  </FormattedMessage>
);

const FormattedMessageAnchor = ({
  className,
  href,
  target,
  onClick,
  ...rest
}) => {
  const onLinkClick = (e) => {
    ClickLayer('link');
    if (onClick) {
      e.preventDefault();
      onClick(e);
    }
  };
  return (
    <FormattedMessage {...rest}>
      {(txt) => (
        <a
          className={className}
          href={href}
          target={target}
          onClick={onLinkClick}
          dangerouslySetInnerHTML={{ __html: txt }}
        />
      )}
    </FormattedMessage>
  );
};

FormattedMessageAnchor.defaultProps = {
  className: '',
  href: '#',
  target: '',
};

const FormattedMessageDiv = (props) => (
  <FormattedMessage {...props}>
    {(txt) => <div className={props.className || ''}>{txt}</div>}
  </FormattedMessage>
);

const FormattedHTMLMessageDiv = (props) => (
  <FormattedMessage {...props}>
    {(txt) => (<div className={props.className || ''} dangerouslySetInnerHTML={{ __html: txt }}/>)}
  </FormattedMessage>
);

export default FormattedMessageWithClass;
export { FormattedMessageAnchor, FormattedMessageDiv, FormattedHTMLMessageDiv };
